import { Pipe, PipeTransform } from '@angular/core';
import { SelectValue } from './select.model';

@Pipe({
  name: 'heading'
})

export class SelectHeadingPipe implements PipeTransform {
  transform(array: SelectValue<any>[], heading = ''): Array<any> {
    return array.filter(x => x.heading == heading);
  }
}
